import { storeToRefs } from 'pinia'

import { useAuthStore } from '@/store/auth'

export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.server) return

  const authStore = useAuthStore()
  const { isAlreadyGetMember } = storeToRefs(authStore)

  if (!isAlreadyGetMember.value) {
    await authStore.getMember()
    isAlreadyGetMember.value = true
  }
})
